import { useContext } from 'react';
import { appContext } from '../../../../AppContext';

import FileProgress from './FileProgress';
import { ValidateButton } from './ValidateButton';

//TODO: Decide on fee error message. Always shown or only in dialog box for awaiting transaction?
//TODO: Create protection from executing functions that is triggered from pending transactions that are not saved in the "sentTxn" state.
//TODO: Decide on if there should be a time limit on accepting a pending transaction.

const ValidateProgress = ({
  // handlePayment,
  handleDataValidation,
  mintOption,
  fee,
  abortController,
  pendingMsg,
  pendingIsOpen,
  setPendingIsOpen,
  usrBalance,
  verifyBtnText,
}) => {
  const { files, validatingFile } = useContext(appContext);

  return (
    <>
      {/* {!validateState && !validationComplete && ( */}
      <FileProgress files={files} validatingFile={validatingFile} />
      {/* )} */}

      <div className="flex flex-col items-center gap-[5px]">
        <ValidateButton
          abortController={abortController}
          // handlePayment={handlePayment}
          handleDataValidation={handleDataValidation}
          verifyBtnText={verifyBtnText}
        />
      </div>
    </>
  );
};

export default ValidateProgress;
